import { render, staticRenderFns } from "./OptionDisplay.vue?vue&type=template&id=a27b7776&"
import script from "./OptionDisplay.vue?vue&type=script&lang=js&"
export * from "./OptionDisplay.vue?vue&type=script&lang=js&"
import style0 from "./OptionDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports